import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Landing from '@pages/Landing';
import InterviewIntro from '@pages/InterviewIntro';
import InterviewSetup from '@pages/InterviewSetup';
import InterviewReady from '@pages/InterviewReady';
import InterviewSession from '@pages/InterviewSession';
import InterviewComplete from '@pages/InterviewComplete';
import SessionExpired from '@pages/SessionExpired';
import Help from '@pages/Help';
import NotFound from '@pages/NotFound';
import Health from '@pages/Health';

import AppLayout from '@/components/Layout/AppLayout';

function App() {
  return (
    <AppLayout>
      <div className="min-h-screen bg-gray-50">
        <Routes>
          <Route path="/" element={<Landing />} />
          
          {/* Help Page */}
          <Route path="/help" element={<Help />} />
          
          {/* Interview Flow */}
          <Route path="/interview/:sessionToken" element={<InterviewIntro />} />
          <Route path="/interview/:sessionToken/setup" element={<InterviewSetup />} />
          <Route path="/interview/:sessionToken/ready" element={<InterviewReady />} />
          <Route path="/interview/:sessionToken/session" element={<InterviewSession />} />
          <Route path="/interview/:sessionToken/complete" element={<InterviewComplete />} />
          
          {/* Health Check */}
          <Route path="/health" element={<Health />} />
          
          {/* Session Expired */}
          <Route path="/session-expired" element={<SessionExpired />} />
          
          {/* 404 */}
          <Route path="/404" element={<NotFound />} />
          <Route path="*" element={<Navigate to="/404" replace />} />
        </Routes>
      </div>
    </AppLayout>
  );
}

export default App;
